import * as React from "react";

export default function EmailIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.84 4.69">
      <rect
        x="0.2"
        y="0.2"
        width="6.44"
        height="4.29"
        rx="0.46"
        strokeWidth="0.4"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        data-custom-color="true"
      />
      <polyline
        points="6.48 0.35 3.42 2.81 0.35 0.35"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.4"
        data-custom-color="true"
      />
    </svg>
  );
}
